/* eslint-disable max-lines */
import { TIdToPageMap } from 'models/common.model'

import { CheckInboxV1 } from 'modules/email/pages/CheckInboxV1'
import { CheckInboxV2 } from 'modules/email/pages/CheckInboxV2'
import { EmailVariant1 } from 'modules/email/pages/EmailVariant1'
import { EmailVariant2 } from 'modules/email/pages/EmailVariant2'
import { EmailVariant3 } from 'modules/email/pages/EmailVariant3'
import { EmailVariant4 } from 'modules/email/pages/EmailVariant4'
import { EmailVariant5 } from 'modules/email/pages/EmailVariant5'
import { PaymentVariant1 } from 'modules/payment/pages/PaymentVariant1'
import { PaymentVariant2 } from 'modules/payment/pages/PaymentVariant2'
import { PaymentVariant3 } from 'modules/payment/pages/PaymentVariant3'
import { PaymentVariant5 } from 'modules/payment/pages/PaymentVariant5'
import { PaymentVariant6 } from 'modules/payment/pages/PaymentVariant6'
import { PaymentVariant7 } from 'modules/payment/pages/PaymentVariant7'
import { CancelOfferSubscriptionVariant1 } from 'modules/subscriptions/pages/CancelOffer'
import { SubscriptionsGoogleVariant1 } from 'modules/subscriptions/pages/SubscriptionsGoogleVariant1'
import { SubscriptionsGoogleVariant2 } from 'modules/subscriptions/pages/SubscriptionsGoogleVariant2'
import { SubscriptionsGoogleVariant4 } from 'modules/subscriptions/pages/SubscriptionsGoogleVariant4'
import { SubscriptionsVariant1 } from 'modules/subscriptions/pages/SubscriptionsVariant1'
import { SubscriptionsVariant3 } from 'modules/subscriptions/pages/SubscriptionsVariant3'
import { SubscriptionsVariant5 } from 'modules/subscriptions/pages/SubscriptionsVariant5'
import {
  UpsellVariant2,
  UpsellVariant3,
} from 'modules/subscriptions/pages/Upsell'

import { AgeRangeVariant2, AgeRangeVariant3 } from 'pages/age-range'
import { BehaviourChangesVariant1 } from 'pages/behaviour-changes'
import { BenefitsVariant2 } from 'pages/benefits'
import { BlackFridayOffer } from 'pages/black-friday-offer'
import { CallsLateVariant1 } from 'pages/calls-late'
import { CatchOnALieVariant1, CatchOnALieVariant2 } from 'pages/catch-on-a-lie'
import { ChatVariant1 } from 'pages/chat'
import { CheatingVariant1, CheatingVariant2 } from 'pages/cheating'
import { DataVariant2 } from 'pages/data'
import { DaysDisclosureVariant1 } from 'pages/days-disclosure'
import { DeleteCallsVariant1 } from 'pages/delete-calls'
import {
  DynamicIntroMultipleChoice,
  DynamicIntroSingleChoice,
  DynamicLeftToRight,
} from 'pages/dynamic-options'
import { FamilySafetyVariant1 } from 'pages/family-safety'
import { FearVariant2 } from 'pages/fear'
import { FeaturesVariant1, FeaturesVariant2 } from 'pages/features'
import { FeedbackVariant1 } from 'pages/feedback'
import { FeelingsVariant2 } from 'pages/feelings'
import { FeltHelplessVariant1 } from 'pages/felt-helpless'
import { GenderVariant1, GenderVariant2 } from 'pages/gender'
import { GetInTouchVariant1 } from 'pages/get-in-touch'
import { GoingOutVariant1 } from 'pages/going-out'
import { InconsistenciesVariant1 } from 'pages/inconsistencies'
import { InterestInPeopleVariant1 } from 'pages/interest-in-people'
import {
  IntroVariant1,
  IntroVariant3,
  IntroVariant5,
  IntroVariant8,
  IntroVariant9,
  IntroVariant10,
  IntroVariant11,
} from 'pages/intro'
import {
  IntroGoogleVariant1,
  IntroGoogleVariant4,
  IntroGoogleVariant5,
} from 'pages/intro-google'
import { LocationVariant1 } from 'pages/location'
import {
  LocationSearchVariant1,
  LocationSearchVariant2,
  LocationSearchVariant3,
} from 'pages/location-search'
import { LocatorAppVariant1 } from 'pages/locator-app'
import { LowBatteryVariant1 } from 'pages/low-battery'
import { OnePlanForEveryoneVariant1 } from 'pages/one-plan-for-everyone'
import { PartnersDataVariant1, PartnersDataVariant2 } from 'pages/partners-data'
import { PhoneHabitsVariant1, PhoneHabitsVariant2 } from 'pages/phone-habits'
import { PhoneNumberVariant3, PhoneNumberVariant4 } from 'pages/phone-number'
import {
  PreparingFlowVariant1,
  PreparingFlowVariant2,
} from 'pages/preparing-flow'
import { ProtectiveOfPhoneVariant1 } from 'pages/protective-of-phone'
import { PutPhoneAwayVariant1 } from 'pages/put-phone-away'
import { QuickWayVariant1 } from 'pages/quick-way'
import { ReasonToJoinVariant1 } from 'pages/reason-to-join'
import { ReasonsVariant2, ReasonsVariant3 } from 'pages/reasons'
import { RoutinesChangesVariant1 } from 'pages/routines-changes'
import {
  SocialProofVariant1,
  SocialProofVariant2,
  SocialProofVariant3,
  SocialProofVariant22,
  SocialProofVariant23,
  SocialProofVariant24,
} from 'pages/social-proof'
import { SosMessageVariant1 } from 'pages/sos-message'
import {
  StayConnectedVariant1,
  StayConnectedVariant2,
} from 'pages/stay-connected'
import { StayOutVariant1 } from 'pages/stay-out'
import { StolenPhoneVariant1 } from 'pages/stolen-phone'
import { SuspiciousActivityVariant1 } from 'pages/suspicious-activity'
import { TakeCallsVariant1 } from 'pages/take-calls'
import { ThankYouVariant1 } from 'pages/thank-you'
import { TopPriorityVariant1 } from 'pages/top-priority'
import { TrackingFrequencyVariant1 } from 'pages/tracking-frequency'
import { UsagePurposeVariant1, UsagePurposeVariant2 } from 'pages/usage-purpose'
import { WhatToDoVariant1 } from 'pages/what-to-do'
import { WishVariant1 } from 'pages/wish'

export const enum CustomPageId {
  PHONE_NUMBER = 'phone_number',
  GENDER = 'gender',
  AGE_RANGE = 'age_range',
  PURPOSE = 'usage_purpose',
}

export const enum PageId {
  INTRO_1 = 'intro_1',
  INTRO_3 = 'intro_3',
  INTRO_5 = 'intro_5',
  INTRO_8 = 'intro_8',
  INTRO_9 = 'intro_9',
  INTRO_10 = 'intro_10',
  INTRO_11 = 'intro_11',
  INTRO_GOOGLE_1 = 'intro_google_1',
  INTRO_GOOGLE_4 = 'intro_google_4',
  INTRO_GOOGLE_5 = 'intro_google_5',
  BENEFITS_2 = 'benefits_2',
  CATCH_ON_A_LIE_1 = 'catch_on_a_lie_1',
  CATCH_ON_A_LIE_2 = 'catch_on_a_lie_2',
  BEHAVIOUR_CHANGES_1 = 'behaviour_changes_1',
  ROUTINES_CHANGES_1 = 'routines_changes_1',
  DAYS_DISCLOSURE_1 = 'days_disclosure_1',
  INCONSISTENCIES_1 = 'inconsistencies_1',
  INTEREST_IN_PEOPLE_1 = 'interest_in_people_1',
  PHONE_HABITS_1 = 'phone_habits_1',
  PHONE_HABITS_2 = 'phone_habits_2',
  PROTECTIVE_OF_PHONE_1 = 'protective_of_phone_1',
  TAKE_CALLS_1 = 'take_calls_1',
  CALLS_LATE_1 = 'calls_late_1',
  DELETE_CALLS_1 = 'delete_calls_1',
  PUT_PHONE_AWAY_1 = 'put_phone_away_1',
  SUSPICIOUS_ACTIVITY_1 = 'suspicious_activity_1',
  GOING_OUT_1 = 'going_out_1',
  STAY_OUT_1 = 'stay_out_1',
  STAY_CONNECTED_1 = 'stay_connected_1',
  STAY_CONNECTED_2 = 'stay_connected_2',
  FAMILY_SAFETY_1 = 'family_safety_1',
  ONE_PLAN_FOR_EVERYONE_1 = 'one_plan_for_everyone_1',
  CHEATING_1 = 'cheating_1',
  CHEATING_2 = 'cheating_2',
  GENDER_1 = 'gender_1',
  GENDER_2 = 'gender_2',
  AGE_RANGE_2 = 'age_range_2',
  AGE_RANGE_3 = 'age_range_3',
  LOCATOR_APP_1 = 'locator_app_1',
  PARTNERS_DATA_1 = 'partners_data_1',
  PARTNERS_DATA_2 = 'partners_data_2',
  DATA_2 = 'data_2',
  TRACKING_FREQUENCY_1 = 'tracking_frequency_1',
  REASONS_2 = 'reasons_2',
  REASONS_3 = 'reasons_3',
  LOCATION_1 = 'location_1',
  FEAR_2 = 'fear_2',
  FEELINGS_2 = 'feelings_2',
  SOCIAL_PROOF_1 = 'social_proof_1',
  SOCIAL_PROOF_2 = 'social_proof_2',
  SOCIAL_PROOF_3 = 'social_proof_3',
  SOCIAL_PROOF_22 = 'social_proof_22',
  SOCIAL_PROOF_23 = 'social_proof_23',
  SOCIAL_PROOF_24 = 'social_proof_24',
  GET_IN_TOUCH_1 = 'get_in_touch_1',
  WISH_1 = 'wish_1',
  TOP_PRIORITY_1 = 'top_priority_1',
  FELT_HELPLESS_1 = 'felt_helpless_1',
  REASON_TO_JOIN_1 = 'reason_to_join_1',
  LOW_BATTERY_1 = 'low_battery_1',
  WHAT_TO_DO_1 = 'what_to_do_1',
  STOLEN_PHONE_1 = 'stolen_phone_1',
  SOS_MESSAGE_1 = 'sos_message_1',
  QUICK_WAY_1 = 'quick_way_1',
  PHONE_NUMBER_3 = 'phone_number_3',
  PHONE_NUMBER_4 = 'phone_number_4',
  FEEDBACK_1 = 'feedback_1',
  PREPARING_FLOW_1 = 'preparing_flow_1',
  PREPARING_FLOW_2 = 'preparing_flow_2',
  LOCATION_SEARCH_1 = 'location_search_1',
  LOCATION_SEARCH_2 = 'location_search_2',
  LOCATION_SEARCH_3 = 'location_search_3',
  DYNAMIC_LEFT_TO_RIGHT = 'dynamic_left_to_right',
  DYNAMIC_INTRO_SINGLE_CHOICE = 'dynamic_intro_single_choice',
  DYNAMIC_INTRO_MULTIPLE_CHOICE = 'dynamic_intro_multiple_choice',
  CHAT_1 = 'chat_1',
  FEATURES_1 = 'features_1',
  FEATURES_2 = 'features_2',
  USAGE_PURPOSE_1 = 'usage_purpose_1',
  USAGE_PURPOSE_2 = 'usage_purpose_2',
  BLACK_FRIDAY_OFFER_1 = 'black_friday_offer_1',
  THANK_YOU_1 = 'thank_you_1',
  ALL_SET_1 = 'all_set_1',
  EMAIL_1 = 'email_1',
  EMAIL_2 = 'email_2',
  EMAIL_3 = 'email_3',
  EMAIL_4 = 'email_4',
  EMAIL_5 = 'email_5',
  SUBSCRIPTIONS_1 = 'subscriptions_1',
  SUBSCRIPTIONS_3 = 'subscriptions_3',
  SUBSCRIPTIONS_5 = 'subscriptions_5',
  SUBSCRIPTIONS_GOOGLE_1 = 'subscriptions_google_1',
  SUBSCRIPTIONS_GOOGLE_2 = 'subscriptions_google_2',
  SUBSCRIPTIONS_GOOGLE_4 = 'subscriptions_google_4',
  CANCEL_OFFER_SUBSCRIPTIONS_1 = 'cancel_offer_subscriptions_1',
  UPSELL_2 = 'upsell_2',
  UPSELL_3 = 'upsell_3',
  PAYMENT_1 = 'payment_1',
  PAYMENT_2 = 'payment_2',
  PAYMENT_3 = 'payment_3',
  PAYMENT_5 = 'payment_5',
  PAYMENT_6 = 'payment_6',
  PAYMENT_7 = 'payment_7',
  ACCOUNT = 'account',
  DOWNLOAD = 'download',
  PRIVACY_POLICY = 'privacy-policy',
  TERMS_OF_USE = 'terms-of-use',
  COOKIE_POLICY = 'cookie-policy',
  CHECK_INBOX_1 = 'check_inbox_1',
  CHECK_INBOX_2 = 'check_inbox_2',
}

export const ID_TO_PAGE_MAP: TIdToPageMap = {
  [PageId.INTRO_1]: IntroVariant1,
  [PageId.INTRO_3]: IntroVariant3,
  [PageId.INTRO_5]: IntroVariant5,
  [PageId.INTRO_8]: IntroVariant8,
  [PageId.INTRO_9]: IntroVariant9,
  [PageId.INTRO_10]: IntroVariant10,
  [PageId.INTRO_11]: IntroVariant11,
  [PageId.INTRO_GOOGLE_1]: IntroGoogleVariant1,
  [PageId.INTRO_GOOGLE_4]: IntroGoogleVariant4,
  [PageId.INTRO_GOOGLE_5]: IntroGoogleVariant5,
  [PageId.BENEFITS_2]: BenefitsVariant2,
  [PageId.AGE_RANGE_2]: AgeRangeVariant2,
  [PageId.AGE_RANGE_3]: AgeRangeVariant3,
  [PageId.BEHAVIOUR_CHANGES_1]: BehaviourChangesVariant1,
  [PageId.CATCH_ON_A_LIE_1]: CatchOnALieVariant1,
  [PageId.CATCH_ON_A_LIE_2]: CatchOnALieVariant2,
  [PageId.ROUTINES_CHANGES_1]: RoutinesChangesVariant1,
  [PageId.DAYS_DISCLOSURE_1]: DaysDisclosureVariant1,
  [PageId.INCONSISTENCIES_1]: InconsistenciesVariant1,
  [PageId.INTEREST_IN_PEOPLE_1]: InterestInPeopleVariant1,
  [PageId.PHONE_HABITS_1]: PhoneHabitsVariant1,
  [PageId.PHONE_HABITS_2]: PhoneHabitsVariant2,
  [PageId.PROTECTIVE_OF_PHONE_1]: ProtectiveOfPhoneVariant1,
  [PageId.TAKE_CALLS_1]: TakeCallsVariant1,
  [PageId.CALLS_LATE_1]: CallsLateVariant1,
  [PageId.DELETE_CALLS_1]: DeleteCallsVariant1,
  [PageId.PUT_PHONE_AWAY_1]: PutPhoneAwayVariant1,
  [PageId.SUSPICIOUS_ACTIVITY_1]: SuspiciousActivityVariant1,
  [PageId.GOING_OUT_1]: GoingOutVariant1,
  [PageId.STAY_OUT_1]: StayOutVariant1,
  [PageId.STAY_CONNECTED_1]: StayConnectedVariant1,
  [PageId.STAY_CONNECTED_2]: StayConnectedVariant2,
  [PageId.FAMILY_SAFETY_1]: FamilySafetyVariant1,
  [PageId.ONE_PLAN_FOR_EVERYONE_1]: OnePlanForEveryoneVariant1,
  [PageId.CHEATING_1]: CheatingVariant1,
  [PageId.CHEATING_2]: CheatingVariant2,
  [PageId.GENDER_1]: GenderVariant1,
  [PageId.GENDER_2]: GenderVariant2,
  [PageId.LOCATOR_APP_1]: LocatorAppVariant1,
  [PageId.PARTNERS_DATA_1]: PartnersDataVariant1,
  [PageId.PARTNERS_DATA_2]: PartnersDataVariant2,
  [PageId.DATA_2]: DataVariant2,
  [PageId.TRACKING_FREQUENCY_1]: TrackingFrequencyVariant1,
  [PageId.REASONS_2]: ReasonsVariant2,
  [PageId.REASONS_3]: ReasonsVariant3,
  [PageId.LOCATION_1]: LocationVariant1,
  [PageId.FEAR_2]: FearVariant2,
  [PageId.FEELINGS_2]: FeelingsVariant2,
  [PageId.SOCIAL_PROOF_1]: SocialProofVariant1,
  [PageId.SOCIAL_PROOF_2]: SocialProofVariant2,
  [PageId.SOCIAL_PROOF_3]: SocialProofVariant3,
  [PageId.SOCIAL_PROOF_22]: SocialProofVariant22,
  [PageId.SOCIAL_PROOF_23]: SocialProofVariant23,
  [PageId.SOCIAL_PROOF_24]: SocialProofVariant24,
  [PageId.GET_IN_TOUCH_1]: GetInTouchVariant1,
  [PageId.WISH_1]: WishVariant1,
  [PageId.TOP_PRIORITY_1]: TopPriorityVariant1,
  [PageId.FELT_HELPLESS_1]: FeltHelplessVariant1,
  [PageId.REASON_TO_JOIN_1]: ReasonToJoinVariant1,
  [PageId.LOW_BATTERY_1]: LowBatteryVariant1,
  [PageId.WHAT_TO_DO_1]: WhatToDoVariant1,
  [PageId.STOLEN_PHONE_1]: StolenPhoneVariant1,
  [PageId.SOS_MESSAGE_1]: SosMessageVariant1,
  [PageId.QUICK_WAY_1]: QuickWayVariant1,
  [PageId.PHONE_NUMBER_3]: PhoneNumberVariant3,
  [PageId.PHONE_NUMBER_4]: PhoneNumberVariant4,
  [PageId.FEEDBACK_1]: FeedbackVariant1,
  [PageId.PREPARING_FLOW_1]: PreparingFlowVariant1,
  [PageId.PREPARING_FLOW_2]: PreparingFlowVariant2,
  [PageId.LOCATION_SEARCH_1]: LocationSearchVariant1,
  [PageId.LOCATION_SEARCH_2]: LocationSearchVariant2,
  [PageId.LOCATION_SEARCH_3]: LocationSearchVariant3,
  [PageId.CHAT_1]: ChatVariant1,
  [PageId.FEATURES_1]: FeaturesVariant1,
  [PageId.FEATURES_2]: FeaturesVariant2,
  [PageId.USAGE_PURPOSE_1]: UsagePurposeVariant1,
  [PageId.USAGE_PURPOSE_2]: UsagePurposeVariant2,
  [PageId.BLACK_FRIDAY_OFFER_1]: BlackFridayOffer,
  [PageId.THANK_YOU_1]: ThankYouVariant1,
  [PageId.DYNAMIC_LEFT_TO_RIGHT]: DynamicLeftToRight,
  [PageId.DYNAMIC_INTRO_SINGLE_CHOICE]: DynamicIntroSingleChoice,
  [PageId.DYNAMIC_INTRO_MULTIPLE_CHOICE]: DynamicIntroMultipleChoice,
  [PageId.EMAIL_1]: EmailVariant1,
  [PageId.EMAIL_2]: EmailVariant2,
  [PageId.EMAIL_3]: EmailVariant3,
  [PageId.EMAIL_4]: EmailVariant4,
  [PageId.EMAIL_5]: EmailVariant5,
  [PageId.SUBSCRIPTIONS_1]: SubscriptionsVariant1,
  [PageId.SUBSCRIPTIONS_3]: SubscriptionsVariant3,
  [PageId.SUBSCRIPTIONS_5]: SubscriptionsVariant5,
  [PageId.SUBSCRIPTIONS_GOOGLE_1]: SubscriptionsGoogleVariant1,
  [PageId.SUBSCRIPTIONS_GOOGLE_2]: SubscriptionsGoogleVariant2,
  [PageId.SUBSCRIPTIONS_GOOGLE_4]: SubscriptionsGoogleVariant4,
  [PageId.CANCEL_OFFER_SUBSCRIPTIONS_1]: CancelOfferSubscriptionVariant1,
  [PageId.CHECK_INBOX_1]: CheckInboxV1,
  [PageId.CHECK_INBOX_2]: CheckInboxV2,
  [PageId.UPSELL_2]: UpsellVariant2,
  [PageId.UPSELL_3]: UpsellVariant3,
  [PageId.PAYMENT_1]: PaymentVariant1,
  [PageId.PAYMENT_2]: PaymentVariant2,
  [PageId.PAYMENT_3]: PaymentVariant3,
  [PageId.PAYMENT_5]: PaymentVariant5,
  [PageId.PAYMENT_6]: PaymentVariant6,
  [PageId.PAYMENT_7]: PaymentVariant7,
}
